import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_ITEMS_BY_ORDER_ID = '[ORDER ITEMS] GET ITEMS BY ORDER ID'
export const SAVE_ORDER_ITEM = '[ORDER ITEMS] SAVE ORDER ITEM'
export const ADD_QUANTITY_TO_ORDER_ITEM = '[ORDER ITEMS] ADD QUANTITY TO ORDER ITEM'
export const SUBTRACT_QUANTITY_TO_ORDER_ITEM = '[ORDER ITEMS] SUBTRACT QUANTITY TO ORDER ITEM'
export const SAVE_ORDER_ITEM_DESCRIPTION = '[ORDER ITEMS] SAVE ORDER ITEM DESCRIPTION'
export const UPDATE_ORDER_ITEM_PRICE = '[ORDER ITEMS] UPDATE ORDER ITEM PRICE'
export const REMOVE_ORDER_ITEM = '[ORDER ITEMS] REMOVE ORDER ITEM'

export function getItemsByOrderIdAction(orderId) {
  const request = api.get(`/order-items/by-order/${orderId}`)
  return (dispatch) => {
    dispatch({ type: GET_ITEMS_BY_ORDER_ID, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ITEMS_BY_ORDER_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_ITEMS_BY_ORDER_ID, error)
    }).finally(() => {
      dispatch({ type: GET_ITEMS_BY_ORDER_ID, payload: { loading: false } })
    })
  }
}

export function saveOrderItemAction(data) {
  const request = api.post(`/order-item/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_ORDER_ITEM, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_ORDER_ITEM, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_ORDER_ITEM, error)
    }).finally(() => {
      dispatch({ type: SAVE_ORDER_ITEM, payload: { saving: false } })
    })
  }
}

export function addQuantityToOrderItemAction(orderItemId, quantity) {
  const request = api.put(`/order-item/${orderItemId}/add-quantity/${quantity}`)
  return (dispatch) => {
    dispatch({ type: ADD_QUANTITY_TO_ORDER_ITEM, payload: { adding_id: orderItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: ADD_QUANTITY_TO_ORDER_ITEM, payload: { added_id: orderItemId, data: response.data.data } })
    }).catch((error) => {
      console.log(ADD_QUANTITY_TO_ORDER_ITEM, error)
    }).finally(() => {
      dispatch({ type: ADD_QUANTITY_TO_ORDER_ITEM, payload: { adding_id: orderItemId } })
    })
  }
}

export function subtractQuantityToOrderItemAction(orderItemId, quantity, productSerieId = null) {
  const request = api.put(`/order-item/${orderItemId}/subtract-quantity/${quantity}/${productSerieId}`)
  return (dispatch) => {
    dispatch({ type: SUBTRACT_QUANTITY_TO_ORDER_ITEM, payload: { subtracting_id: orderItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SUBTRACT_QUANTITY_TO_ORDER_ITEM, payload: { subtracted_id: orderItemId, data: response.data.data } })
    }).catch((error) => {
      console.log(SUBTRACT_QUANTITY_TO_ORDER_ITEM, error)
    }).finally(() => {
      dispatch({ type: SUBTRACT_QUANTITY_TO_ORDER_ITEM, payload: { subtracting_id: orderItemId } })
    })
  }
}

export function saveOrderItemDescriptionAction(orderItemId, description) {
  const request = api.put(`/order-item/${orderItemId}/description/${description}`)
  return (dispatch) => {
    dispatch({ type: SAVE_ORDER_ITEM_DESCRIPTION, payload: { saving_id: orderItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_ORDER_ITEM_DESCRIPTION, payload: { saved_id: orderItemId, data: response.data.data } })
    }).catch((error) => {
      console.log(SAVE_ORDER_ITEM_DESCRIPTION, error)
    }).finally(() => {
      dispatch({ type: SAVE_ORDER_ITEM_DESCRIPTION, payload: { saving_id: orderItemId } })
    })
  }
}

export function updateOrderItemPriceAction(orderItemId, price, password = null) {
  const request = api.put(`/order-item/${orderItemId}/price/${price}/${password}`)
  return (dispatch) => {
    dispatch({ type: UPDATE_ORDER_ITEM_PRICE, payload: { updating_id: orderItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UPDATE_ORDER_ITEM_PRICE, payload: { updated_id: orderItemId, data: response.data.data } })
    }).catch((error) => {
      console.log(UPDATE_ORDER_ITEM_PRICE, error)
    }).finally(() => {
      dispatch({ type: UPDATE_ORDER_ITEM_PRICE, payload: { updating_id: orderItemId } })
    })
  }
}

export function removeOrderItemAction(orderItemId) {
  const request = api.delete(`/order-item/remove/${orderItemId}`)
  return (dispatch) => {
    dispatch({ type: REMOVE_ORDER_ITEM, payload: { removing_id: orderItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_ORDER_ITEM, payload: { removed_id: orderItemId } })
    }).catch((error) => {
      console.log(REMOVE_ORDER_ITEM, error)
    }).finally(() => {
      dispatch({ type: REMOVE_ORDER_ITEM, payload: { removing_id: orderItemId } })
    })
  }
}
